import type {FC, InputHTMLAttributes} from 'react'

interface Props {
  left?: JSX.Element
  data? : { label: string, value: string }[] | [],
  id: string, 
  onChanges?: (e : any) => void ,
  value?: string,
  disabled? : boolean,
  validation? : any
  textError?: any
}

const Dropdown: FC<Props & InputHTMLAttributes<HTMLInputElement>> = ({
  left,
  data,
  id,
  onChanges,
  value,
  disabled,
  validation,
  textError,
  ...props
}) => {
 
  return (
    <div>
      {left && <span className='input-group-text'>{left}</span>}
      <select onChange={onChanges} disabled={disabled}   className="form-select" aria-label="Select example" id={id} name={id} value={value} >
        <option value="">Open this select menu</option>
        {data?.map((item, index) => (
             <option key={index} value={item.value}>{item.label}</option>
        ))}
      </select>
      {validation?  <div className='form-label m-2  text-danger bold'>
        {textError}
      </div> : null}
    </div>
  )
}

export default Dropdown
